import { render, staticRenderFns } from "./AppSelectableButton.vue?vue&type=template&id=3d896b4e&"
import script from "./AppSelectableButton.vue?vue&type=script&lang=ts&"
export * from "./AppSelectableButton.vue?vue&type=script&lang=ts&"
import style0 from "./AppSelectableButton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAction } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VList,VListItem,VListItemAction,VMenu})
